import { PillSelect } from "@/components/we360/PillSelect";
import { CheckOption } from "@/components/we360/CheckOption";
import { TextInput } from "@/components/we360/TextInput";
import { MOTIVATION_GOALS, MOTIVATION_LEVELS, RESTRICTION_OPTIONS } from "./helpers";

export default function Step5Motivation({
  motivaciones, onToggleMotivacion,
  nivelMotivacion, onNivelChange,
  restricciones, onToggleRestriccion,
  restriccionOtra, onRestriccionOtraChange,
  alergias, onAlergiasChange,
  errors,
}) {
  const showOtraField = restricciones.includes("Otra");

  return (
    <div>
      {/* Motivación */}
      <p className="text-xs font-bold mb-2 uppercase tracking-wide" style={{ color: "#71644C" }}>
        Motivación
      </p>
      <p className="text-xs mb-3" style={{ color: "#2D2A24" }}>
        ¿Qué te motiva a mejorar tu alimentación? (selecciona las que apliquen)
      </p>
      <div className="mb-4">
        {MOTIVATION_GOALS.map((g) => (
          <CheckOption
            key={g}
            label={g}
            checked={motivaciones.includes(g)}
            onChange={() => onToggleMotivacion(g)}
            testId={`f4-goal-${g.toLowerCase().replace(/[\s\/]/g, "-")}`}
          />
        ))}
        {errors?.getError("motivaciones") && (
          <p className="text-xs mt-1 font-medium" style={{ color: "#C0453A" }} data-testid="f4-motivaciones-error">
            {errors.getError("motivaciones")}
          </p>
        )}
      </div>

      <PillSelect
        label="¿Qué tan motivado/a te sientes para mejorar tu alimentación?"
        options={MOTIVATION_LEVELS}
        value={nivelMotivacion}
        onChange={onNivelChange}
        error={errors?.getError("nivelMotivacion")}
        testId="f4-motivation-level"
        columns={1}
      />

      {/* Restricciones */}
      <div className="mt-5 pt-4" style={{ borderTop: "1px solid #E2D9CB" }}>
        <p className="text-xs font-bold mb-2 uppercase tracking-wide" style={{ color: "#71644C" }}>
          Restricciones y preferencias
        </p>
        <p className="text-xs mb-3" style={{ color: "#2D2A24" }}>
          ¿Tienes alguna restricción o estilo de alimentación especial? (selecciona las que apliquen)
        </p>
        <div className="mb-4">
          {RESTRICTION_OPTIONS.map((r) => (
            <CheckOption
              key={r}
              label={r}
              checked={restricciones.includes(r)}
              onChange={() => onToggleRestriccion(r)}
              testId={`f4-restriction-${r.toLowerCase().replace(/[\s\/()]/g, "-")}`}
            />
          ))}
        </div>

        {showOtraField && (
          <TextInput
            label="Especifica cuál"
            value={restriccionOtra}
            onChange={onRestriccionOtraChange}
            placeholder="Escribe tu restricción..."
            testId="f4-restriccion-otra-input"
          />
        )}

        <div className="mt-3">
          <label className="block text-xs font-semibold mb-1.5" style={{ color: "#2D2A24" }}>
            Si tienes alergias alimentarias, descríbelas aquí
          </label>
          <textarea
            value={alergias}
            onChange={(e) => onAlergiasChange(e.target.value)}
            placeholder="Ej: alérgico/a a maní, mariscos..."
            data-testid="f4-alergias-textarea"
            className="we-input w-full"
            style={{ minHeight: 70, resize: "vertical" }}
          />
        </div>
      </div>
    </div>
  );
}
